import React, { useState } from 'react';
import { useAuth } from '../context/auth-context';
import { discordService } from '../services/discord-service';
import '../App.css'; 

const LiveScoringPreview = () => (
  <div className="discord-message">
    <div className="discord-avatar">H</div>
    <div className="discord-message-content">
      <div className="discord-author">Harambot <span className="discord-bot-tag">BOT</span></div>
      <div className="discord-embed discord-embed-blue">
        <div className="discord-embed-title">🏈 Week 12 Matchup</div>
        <div className="matchup-header">
          <span className="team-name">Team Harambe</span>
          <span className="matchup-score">98.42</span>
          <span className="matchup-vs">vs</span>
          <span className="matchup-score">87.16</span>
          <span className="team-name">Gorilla Gang</span>
        </div>
        <div className="discord-embed-fields">
          <div className="discord-embed-field">
            <div className="discord-field-name">Team Harambe</div>
            <div className="discord-field-value">
              J. Allen (QB) — 24.8<br/>
              S. Barkley (RB) — 18.6<br/>
              A. St. Brown (WR) — 22.1<br/>
              T. Kelce (TE) — 14.2<br/>
              D. Henry (RB) — 18.72
            </div>
          </div>
          <div className="discord-embed-field">
            <div className="discord-field-name">Gorilla Gang</div>
            <div className="discord-field-value">
              P. Mahomes (QB) — 19.4<br/>
              B. Robinson (RB) — 15.8<br/>
              J. Chase (WR) — 26.3<br/>
              M. Andrews (TE) — 8.96<br/>
              J. Mixon (RB) — 16.7
            </div>
          </div>
        </div>
        <div className="discord-embed-footer">Live · Updated 2 min ago</div>
      </div>
    </div>
  </div>
);

const LeagueUpdatesPreview = () => (
  <div className="discord-messages-group">
    <div className="discord-message">
      <div className="discord-avatar">H</div>
      <div className="discord-message-content">
        <div className="discord-author">Harambot <span className="discord-bot-tag">BOT</span></div>
        <div className="discord-embed discord-embed-green">
          <div className="discord-embed-title">🔄 Trade Completed</div>
          <div className="discord-embed-fields">
            <div className="discord-embed-field">
              <div className="discord-field-name">Team Harambe receives</div>
              <div className="discord-field-value">Ja'Marr Chase (WR — CIN)</div>
            </div>
            <div className="discord-embed-field">
              <div className="discord-field-name">Gorilla Gang receives</div>
              <div className="discord-field-value">
                Davante Adams (WR — NYJ)<br/>
                2025 Round 2 Pick
              </div>
            </div>
          </div>
          <div className="discord-embed-footer">Harambe League · Today at 3:42 PM</div>
        </div>
      </div>
    </div>
    <div className="discord-message discord-message-continued">
      <div className="discord-message-content">
        <div className="discord-embed discord-embed-yellow">
          <div className="discord-embed-title">📋 Waiver Claim Processed</div>
          <div className="discord-embed-description">
            <strong>Gorilla Gang</strong> added <strong>Jayden Daniels</strong> (QB — WSH), dropped <strong>Geno Smith</strong> (QB — SEA)
          </div>
          <div className="discord-embed-footer">Harambe League · Today at 4:15 AM</div>
        </div>
      </div>
    </div>
  </div>
);

const PlayerStatsPreview = () => (
  <div className="discord-message">
    <div className="discord-avatar">H</div>
    <div className="discord-message-content">
      <div className="discord-author">Harambot <span className="discord-bot-tag">BOT</span></div>
      <div className="discord-command">/player Patrick Mahomes</div>
      <div className="discord-embed discord-embed-red">
        <div className="discord-embed-title">Patrick Mahomes — QB, Kansas City Chiefs</div>
        <div className="discord-embed-fields discord-embed-fields-inline">
          <div className="discord-embed-field-inline">
            <div className="discord-field-name">Pass Yds</div>
            <div className="discord-field-value">4,007</div>
          </div>
          <div className="discord-embed-field-inline">
            <div className="discord-field-name">Pass TD</div>
            <div className="discord-field-value">26</div>
          </div>
          <div className="discord-embed-field-inline">
            <div className="discord-field-name">INT</div>
            <div className="discord-field-value">11</div>
          </div>
          <div className="discord-embed-field-inline">
            <div className="discord-field-name">Rush Yds</div>
            <div className="discord-field-value">389</div>
          </div>
          <div className="discord-embed-field-inline">
            <div className="discord-field-name">Fant Pts</div>
            <div className="discord-field-value">284.6</div>
          </div>
          <div className="discord-embed-field-inline">
            <div className="discord-field-name">Avg/Wk</div>
            <div className="discord-field-value">21.9</div>
          </div>
        </div>
        <div className="discord-embed-footer">2025 Season Stats · Yahoo Fantasy</div>
      </div>
    </div>
  </div>
);

const features = [
  {
    id: 'live-scoring',
    title: 'Live Scoring',
    description: 'Get real-time scoring updates for all your fantasy matchups, right in your Discord server.',
    preview: <LiveScoringPreview />,
  },
  {
    id: 'league-updates',
    title: 'League Updates',
    description: 'Stay on top of trades, waiver claims, and other league activities with instant notifications.',
    preview: <LeagueUpdatesPreview />,
  },
  {
    id: 'player-stats',
    title: 'Player Stats',
    description: 'Look up player stats, projections, and news without ever leaving Discord.',
    preview: <PlayerStatsPreview />,
  },
];

function Home() {
  const { user, guilds, isAuthenticated } = useAuth();
  const [activeFeature, setActiveFeature] = useState<string | null>(null);

  return (
    <div className="home">
      <header className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">The Ultimate Fantasy Sports Companion</h1>
          <p className="hero-subtitle">
            Harambot is a Discord bot that brings your Yahoo Fantasy Sports leagues to directly to your servers with transaction alerts, custom commands, and more.
          </p>
          <p className="hero-tagline">
            <i>An Interactive Yahoo Fantasy Bot for Discord</i>
          </p>
          {!isAuthenticated && (
            <div className="hero-buttons">
              <a href="https://discord.com/oauth2/authorize?client_id=732739283430441081&permissions=274878220288&scope=bot" className="btn btn-primary">Add to Discord</a>
              <a href="https://discord.gg/h5DE2d7" className="btn btn-secondary">Join Server</a>
            </div>
          )}
        </div>
      </header>

      {isAuthenticated && user && (
        <section className="guilds-section">
          <div className="container">
            <h2 className="section-title">Your Servers</h2>
            <p className="section-subtitle">Select a server to add Harambot</p>
            {guilds.length > 0 ? (
              <div className="guilds-grid">
                {guilds.map((guild) => (
                  <div key={guild.id} className="guild-card">
                    <img 
                      src={discordService.getGuildIconUrl(guild.id, guild.icon)} 
                      alt={guild.name} 
                      className="guild-icon"
                    />
                    <h3 className="guild-name">{guild.name}</h3>
                    <a 
                      href={discordService.getAddBotUrl(guild.id)} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="btn btn-small"
                    >
                      Add Harambot
                    </a>
                  </div>
                ))}
              </div>
            ) : (
              <p className="no-guilds">No servers found where you have "Manage Server" permissions.</p>
            )}
          </div>
        </section>
      )}

      <section className="features-section">
        <div className="container">
          <h2 className="section-title">Features</h2>
          <div className="features-grid">
            {features.map((feature) => (
              <div
                key={feature.id}
                className={`feature-card ${activeFeature === feature.id ? 'feature-card-active' : ''}`}
                onClick={() => setActiveFeature(activeFeature === feature.id ? null : feature.id)}
              >
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
                <span className="feature-card-hint">
                  {activeFeature === feature.id ? 'Click to close' : 'Click to preview'}
                </span>
              </div>
            ))}
          </div>
          {activeFeature && (
            <div className="feature-preview">
              {features.find((f) => f.id === activeFeature)?.preview}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default Home;